import React from "react";
import { Loader2 } from "lucide-react";

export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex flex-col items-center justify-center">
      {/* MyTrailer Logo */}
      <div className="text-center mb-8">
        <img 
          src="/MyTrailerLogo.png" 
          alt="MyTrailer Logo" 
          className="h-20 sm:h-24 mx-auto mb-6"
        />
      </div>
      
      {/* Loading Spinner */}
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-[#51380d]" />
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Please wait...</h2>
          <p className="text-gray-600">Loading your MyTrailer dashboard</p>
        </div>
      </div>
      
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-[#51380d]/5 to-[#3d2a0a]/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-tr from-[#51380d]/5 to-[#3d2a0a]/5 rounded-full blur-3xl"></div>
      </div>
    </div>
  );
}
